import { render } from "./SocialMediaPosting.vue?vue&type=template&id=070b3667&scoped=true"
import script from "./SocialMediaPosting.vue?vue&type=script&lang=js"
export * from "./SocialMediaPosting.vue?vue&type=script&lang=js"

import "./SocialMediaPosting.vue?vue&type=style&index=0&id=070b3667&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1919945302/src/app.tamildata.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-070b3667"]])

export default __exports__